export default __webpack_public_path__ + "static/ice_machine_w.1f9250090f613ef19c9de9a572bdc9a3.png";